import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/core/api/user/user.service';
import { AuthenticatedUserService } from 'src/app/core/services/authenticated-user/authenticated-user.service';
import { BusinessSummaryResponseDTO } from 'src/app/shared/models/dtos/responses/business-summary-response-dto/business-summary-response-dto';

@Component({
  selector: 'app-customer-detail',
  templateUrl: './customer-detail.component.html',
  styleUrls: ['./customer-detail.component.scss'],
})
/**
 * Customer Detail content
 */
export class CustomerDetailComponent implements OnInit, OnDestroy {
  @Input() businessId!: number;
  businessSummary!: BusinessSummaryResponseDTO;
  detail!: string;
  private readonly subsink = new Subscription();
  viewOnly!: boolean;
  hasBusinessInfo: boolean = false;

  /**
   * @constructor
   */
  constructor(
    private readonly route: ActivatedRoute,
    private readonly userService: UserService,
    private readonly authenticatedUserService: AuthenticatedUserService
  ) {}

  /**
   * on init
   */
  ngOnInit(): void {
    this.reloadBusinessSummary();

    this.subsink.add(
      this.route.queryParams.subscribe((params) => {
        this.detail = params['detail'];
      })
    );
    this.viewOnly =
      this.authenticatedUserService.isVOAdmin() ||
      this.authenticatedUserService.isCallCenterAgent();
  }

  /**
   * Fetches business summary and updates the fixed header (app-photo-name).
   * Called on init and whenever a child component reports the business
   * data was changed, so the header stays in sync without a page reload.
   */
  reloadBusinessSummary(): void {
    this.userService
      .getBusinessSummary(this.businessId)
      .subscribe((summary) => {
        this.businessSummary = summary;
      });
  }

  /**
   * on destroy
   */
  ngOnDestroy() {
    this.subsink.unsubscribe();
  }
}
